import { Component, Input } from '@angular/core';
import { EditOrderLineComponent } from 'components/sale/edit-order-line.component';
import { CredentialType } from 'enums/CredentialType';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { BrandService } from 'services/brand.service';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { SalesService } from 'services/sales.service';
import { SelectListItemModel } from 'models/SelectList';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';

@Component({
	selector: 'company-product-plan-create',
	templateUrl: './create-product-plan.component.html',
	providers: [FormValidationService],
	imports: [Layout, EditOrderLineComponent, TranslatePipe, CustomSelectComponent]
})
@CredentialRequired(CredentialType.CreateProductPlanManually)
export class CreateProductPlanComponent {

	orderLine = Object.assign(new OrderLineModel(), { quantity: 1, paymentInterval: 0 });

	@Input() companyId!: string;
	brandId?: string;
	brands: SelectListItemModel[];

	constructor(
		private salesService: SalesService,
		private navigation: NavigationService,
		private readonly brandService: BrandService
	) {
		this.brands = brandService.brands.map(b => new SelectListItemModel(b.id!, b.name));
	}

	async saveProductPlan() {
		if (!this.brandId) return;
		if (!this.orderLine.productVariant) return;
		await this.salesService.createProductPlanFromOrderLines([this.orderLine], this.companyId, this.brandId);
		this.closeDialog();
	}

	closeDialog(): void {
		this.navigation.closeView(this);
	}
}
